// Land-use term parameters for the term-correction factor.
//
// Per rules/FACTOR_TABLES_MVP.md §4:
//
//   K = [1 - 1/(1+r)^m] / [1 - 1/(1+r)^n]
//
// MVP computes K on demand (the function lives in logic/, not here). This
// file only carries the r/n parameters keyed by applicable price type.

import type { ApplicablePriceType } from "../types/enums.js";

export interface LandTermParams {
  /** Discount rate r. */
  readonly r: number;
  /** Standard term n (years). */
  readonly n: number;
}

export const LAND_TERM_PARAMS: Readonly<
  Record<ApplicablePriceType, LandTermParams>
> = {
  住宅: { r: 0.041, n: 70 },
  商业: { r: 0.046, n: 40 },
  办公: { r: 0.047, n: 40 },
  工业: { r: 0.044, n: 30 },
  新型产业: { r: 0.045, n: 30 },
  酒店: { r: 0.05, n: 40 },
  公共管理与服务设施: { r: 0.036, n: 50 },
  公用设施: { r: 0.034, n: 50 },
};
